export const formatNumber = (numero, decimales, prefijo, sufijo) => {
    let number = (Math.round(numero * 100) / 100).toFixed(decimales);
    const decimalsFormated = number.toLocaleString(undefined, { maximumFractionDigits: decimales });
    const finalFormated = prefijo + String(decimalsFormated).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + sufijo;
    return finalFormated;    
}

export const formatTexto = (texto) => {
    let textoConEspacios = texto.replace(/_/g, ' ');
    let textoCapitalizado = textoConEspacios.charAt(0).toUpperCase() + textoConEspacios.slice(1);
    
    return textoCapitalizado;
}

export const roundNumber = (numero, decimales = 2) => {
    return parseFloat(numero.toFixed(decimales));
}

export const printTicket = async (venta) => {
    let cliente = venta?.cliente?.nombre ? venta?.cliente?.nombre + ' ' + venta?.cliente?.apellido : 'Público general';

    let metodo = 'Sin definir';

    if (venta?.metodos?.length > 0) {
        const nombres = venta.metodos
            .map(m => m.metodo?.nombre)
            .filter(Boolean);

        if (nombres.length == 1) {
            metodo = nombres[0];
        } else if (nombres.length == 2) {
            metodo = `${nombres[0]} y ${nombres[1]}`;
        } else {
            metodo = `${nombres.slice(0, -1).join(', ')} y ${nombres[nombres.length - 1]}`;
        }
    }

    const tienePrecioCero = venta.productos?.some(p => parseFloat(p.precio || 0) === 0);

    let productos = venta.productos?.length ? '<hr /><p><strong>Productos</strong></p>' : '';
    let servicios = venta.servicios?.length ? '<hr /><p><strong>Servicios</strong></p>' : '';

    for (var i = 0; i < venta.productos?.length; i++) {
        if(parseFloat(venta.productos[i].precio || 0) === 0) continue;
        const pImporte = parseFloat(venta.productos[i].cantidad) * parseFloat(venta.productos[i].precio) / (venta.productos[i].conversion || 1);
        const pUnidad = venta.productos[i].unidad?.nombre ? ' (' + venta.productos[i].unidad.nombre + ')' : '';
        productos += '<div class="informativo linea-item"><span>- ' + (venta.productos[i].producto?.nombre_corto || venta.productos[i].producto?.nombre || 'Sin definir') + ' x ' + venta.productos[i].cantidad + pUnidad + '</span><span>' + formatNumber(pImporte, 2, '$ ', '') + '</span></div>';
    }

    if (tienePrecioCero) {
        productos += '<p class="informativo">- Medicamentos y/o materiales de uso intrahospitalario</p>';
    }

    for (var i = 0; i < venta.servicios?.length; i++) {
        const sImporte = (venta.servicios[i].cantidad || 1) * parseFloat(venta.servicios[i].precio || 0);
        servicios += '<div class="informativo linea-item"><span>- ' + (venta.servicios[i].servicio?.nombre_corto || 'Sin definir') + ' x ' + (venta.servicios[i].cantidad || 1) + '</span><span>' + formatNumber(sImporte, 2, '$ ', '') + '</span></div>';
    }

    const ventana = window.open('', '');
    ventana.document.write(`
        <html>
            <head>
            <style>
                @media print {
                    body {
                        font-family: monospace;
                        font-size: 16px;
                        width: 80mm; /* o 80mm según tu papel */
                        margin: 0;
                        padding: 0;
                    }

                    #ticket {
                        width: 80mm;
                    }

                    p {
                        margin: 4px 0;
                    }

                    hr {
                        border: none;
                        border-top: 1px dashed #000;
                        margin: 6px 0;
                    }

                    .informativo {
                        font-size: 14px;
                    }

                    .linea-item {
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }

                    .linea-item span:first-child {
                        flex: 1;
                    }

                    .linea-item span:last-child {
                        white-space: nowrap;
                    }
                }
            </style>
            </head>
            <body onload="window.print(); window.close();">
            <div id="ticket">
                <p style="text-align: center;"><strong>Veterinaria Tostes</strong></p>
                <p class="informativo" style="text-align: center;">María Guadalupe Torres Soto</p>
                <p class="informativo" style="text-align: center;">TOSG750509GD7</p>
                <p class="informativo" style="text-align: center;">Av. Aguascalientes #503; Boulevares 1° Sección; CP 20288.</p>
                <p class="informativo" style="text-align: center;">Tels: 4499780234 y 4499136041</p>
                <p class="informativo" style="text-align: center;">recepcion.tostes@gmail.com</p>
                <p class="informativo" style="text-align: center;"><strong>${venta.fecha && venta.fecha != '0000-00-00' ? new Date(venta.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'numeric', day: 'numeric' }) + ' ' + new Date(venta.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</strong></p>
                <p class="informativo" style="text-align: center;"><strong>Venta al público general</strong></p>
                <hr />
                <p class="informativo"><strong>Folio:</strong> ${venta.folio}</p>
                <p class="informativo"><strong>Cliente:</strong> ${cliente}</p>
                <p class="informativo"><strong>Método de pago:</strong> ${metodo}</p>
                ${venta.medicos?.length ? `<p class="informativo"><strong>Médicos:</strong> ${venta.medicos.map(m => (m.medico?.nombre || '') + ' ' + (m.medico?.apellido || '')).join(', ')}</p>` : ''}
                ${venta.medicos_externos?.length ? `<p class="informativo"><strong>Médicos externos:</strong> ${venta.medicos_externos.map(m => m.medico_externo?.nombre || '').join(', ')}</p>` : ''}
                ${productos}
                ${servicios}
                <hr />
                <p style="text-align: right;"><strong>Total: ${formatNumber((venta.total || 0), 2, '$ ', '')}</strong></p>
                <p style="text-align: center;">¡Gracias por su compra!</p>
                <p style="text-align: center;">Ticket digital: <b>tostes.mx/busqueda</b></p>
            </div>
            </body>
        </html>
    `);

    ventana.document.close();
}